import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IProductReviewsAggregate, IReviewsAggregate, IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetAggregateComponent, ReviewWidgetAggregateComponent } from "./reviewWidgetAggregateComponent";
import { IReviewWidgetFeatureAggregateComponent, ReviewWidgetFeatureAggregateComponent } from "./reviewWidgetFeatureAggregateComponent";
import { IReviewWidgetSummaryComponent, ReviewWidgetSummaryComponent } from "./reviewWidgetSummaryComponent";

export interface IReviewWidgetAggregatePanelBase extends IInstanceComponentBase   {
    reviewsAverage: number; 
    totalReviews: number;
    reviewsAggregate: IReviewsAggregate
    reviewWidgetAggregateComponent: IReviewWidgetAggregateComponent;
    reviewWidgetSummaryComponent: IReviewWidgetSummaryComponent;
    setReviewsAggregate:() => void;
    updateReviewsAggregate: (reviewsAggregate: IReviewsAggregate) => void;
    updateBase:(reviewsAverage: number, totalReviews: number, reviewsSummary: IReviewsSummary) => void;
}

export abstract class ReviewWidgetAggregatePanelBase extends InstanceComponentBase implements IReviewWidgetAggregatePanelBase {
    public reviewsAverage: number; 
    public totalReviews: number;
    public reviewWidgetAggregateComponent: IReviewWidgetAggregateComponent;
    public reviewWidgetSummaryComponent: IReviewWidgetSummaryComponent;
    public reviewsAggregate: IReviewsAggregate = {} as IReviewsAggregate;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
        
        this.createReviewWidgetAggregateComponent();
        this.setTotalReviews();

        this.createReviewWidgetSummaryComponent();

        this.setReviewsAverage();
    }
    
    createReviewWidgetAggregateComponent():void{
        let reviewWidgetAggregateComponentElement: HTMLElement | null = this.getHtmlElementForReviewWidgetAggregateComponent();
        if (reviewWidgetAggregateComponentElement) {
            this.reviewWidgetAggregateComponent = new ReviewWidgetAggregateComponent(reviewWidgetAggregateComponentElement);
        }
    }

    getHtmlElementForReviewWidgetAggregateComponent():HTMLElement{
        let aggregateComponentElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetAggregateComponent.reviewWidgetAggregateComponent))
        return aggregateComponentElement;
    }

    createReviewWidgetSummaryComponent():void{
        let reviewWidgetSummaryComponentElement: HTMLElement | null = this.getHtmlElementForReviewWidgetSummaryComponent();
        if (reviewWidgetSummaryComponentElement) {
            this.reviewWidgetSummaryComponent = new ReviewWidgetSummaryComponent(reviewWidgetSummaryComponentElement);
        }
    }

    getHtmlElementForReviewWidgetSummaryComponent():HTMLElement{
        let summaryComponentElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewWidgetSummaryComponent.reviewWidgetSummaryComponent))
         return summaryComponentElement;
    }

    setReviewsAggregate():void{
        this.reviewsAggregate.reviewsAverage = this.reviewWidgetAggregateComponent.reviewsAverage;
        this.reviewsAggregate.totalReviews = this.reviewWidgetAggregateComponent.totalReviews;
        this.reviewsAggregate.reviewsSummary = this.reviewWidgetSummaryComponent.reviewsSummary;
    }

    updateReviewsAggregate(reviewsAggregate: IReviewsAggregate):void{
        this.reviewWidgetAggregateComponent.update(reviewsAggregate.reviewsAverage, reviewsAggregate.totalReviews);

        this.setReviewsAggregate();
    }

    setReviewsAverage():void{
        this.reviewsAverage = this.reviewWidgetAggregateComponent.reviewsAverage;
    }

    setTotalReviews():void{
        this.totalReviews = this.reviewWidgetAggregateComponent.totalReviews;
    }

    updateBase(reviewsAverage: number, totalReviews: number, reviewsSummary: IReviewsSummary): void {
        this.reviewWidgetAggregateComponent.update(reviewsAverage, totalReviews);
        this.reviewWidgetSummaryComponent.update(reviewsSummary);
        this.setReviewsAverage();
        this.setTotalReviews();
    }

    dispose() {
        try {
            console.log(`ReviewWidgetAggregatePanelBase: dispose`);
           
            if (this.reviewWidgetAggregateComponent) {
                this.reviewWidgetAggregateComponent.dispose();
            }
            if (this.reviewWidgetSummaryComponent) {
                this.reviewWidgetSummaryComponent.dispose();
            }

          
        } catch (error) {
            console.log('ReviewWidgetAggregatePanelBase: dispose ERROR', error);
        }
    }
}

